// Root.js
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import MainNavigation from '../components/MainNavigation';

export default function Root() {
  const [isSidebarVisible, setSidebarVisible] = useState(true);

  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };

  return (
    <>
      <MainNavigation toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
      <div style={contentStyle(isSidebarVisible)}>
        <Outlet />
      </div>
    </>
  );
}

const contentStyle = (isSidebarVisible) => ({
  display: 'flex',
  marginTop: '80px', // Adjust marginTop to header height
  padding: '20px',
  backgroundColor: '#FFFFFF', // White
  minHeight: 'calc(100vh - 80px)', // Adjust height to account for the header
  paddingLeft: isSidebarVisible ? '250px' : '0', // Adjust to account for sidebar width
  transition: 'padding-left 0.3s ease',
});
